import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import { FilterItem, FiltersProp, FilterTypes } from './FilterItem'
import Arrow from 'assets/icons/close.svg'
import { searchStringToObject } from 'use-query-params'
import { Button } from '@material-ui/core'
import DeleteIcon from 'assets/icons/iconsCad/delete.svg'
import { useTranslation } from 'react-i18next'
import { colors } from 'styles/colors'
import CloseIcon from 'assets/icons/Exit.svg'

const Flex = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 15px;
    gap: 10px;
    width: 95vw;
    min-height: 100vh;
    max-width: 310px;
    background-color: #fff;
`

const Icon = styled(DeleteIcon)`
    width: 15px;
    height: 15px;
    margin-top: -3px;
    margin-right: -5px;
    fill: #f50057;
`
const ZonesHeader = styled.div`
    display: flex;
    position: relative;
    padding: 15px 0;
    width: 310px;
    align-items: center;
    justify-content: space-between;
    button {
        padding: 0 30px 0 0;
        font-size: 10px;
    }
    p {
        letter-spacing: 1.5px;
        margin-right: 5px;
        button {
            font-size: 10px;
        }
    }
`
const IconStyled = styled(Arrow)<{ $isZonesVisible: boolean }>`
    position: absolute;
    bottom: 22px;
    stroke: #3a8589;
    stroke-width: 2px;
    right: 0px;
    transform: ${({ $isZonesVisible }) => !$isZonesVisible && 'rotate(180deg)'};
    cursor: pointer;
`
const Zones = styled.div<{ $isZonesVisible: boolean }>`
    display: ${({ $isZonesVisible }) => ($isZonesVisible ? 'block' : 'none')};
    div {
        margin-bottom: 4px;
    }
`

export type ClearHandler = {
    clear: () => void
}

const CloseIconStyled = styled(CloseIcon)`
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    z-index: 50;
    fill: ${colors.white};
    stroke: ${colors.dark};
`

export const filters: FiltersProp[] = [
    {
        type: FilterTypes.RANGE,
        label: 'houseArea',
        min: 50,
        max: 400,
        step: 5,
        marks: [
            {
                value: 50,
                label: '50 m²',
            },
            {
                value: 100,
                label: '100 m²',
            },

            {
                value: 200,
                label: '200 m²',
            },

            {
                value: 300,
                label: '300 m²',
            },

            {
                value: 400,
                label: '400 m²',
            },
        ],
    },
    // {
    //     type: FilterTypes.RANGE,
    //     label: 'houseWidth',
    //     min: 3,
    //     max: 30,
    //     marks: [
    //         {
    //             value: 3,
    //             label: '3 m',
    //         },
    //         {
    //             value: 10,
    //             label: '10 m',
    //         },
    //         {
    //             value: 25,
    //             label: '25 m',
    //         },
    //     ],
    // },
    // {
    //     type: FilterTypes.RANGE,
    //     label: 'houseHeight',
    //     min: 3,
    //     max: 30,
    //     marks: [
    //         {
    //             value: 3,
    //             label: '3 m',
    //         },
    //         {
    //             value: 10,
    //             label: '10 m',
    //         },
    //         {
    //             value: 25,
    //             label: '25 m',
    //         },
    //     ],
    // },
    // {
    //     type: FilterTypes.SELECT,
    //     label: 'project',
    //     items: ['design', 'architect', 'designAndArchitect'],
    // },
    // {
    //     type: FilterTypes.SELECT,
    //     label: 'type',
    //     items: ['flat', 'house', 'comercial'],
    // },
    {
        type: FilterTypes.SELECT,
        label: 'floor',
        items: ['1', '2', '3'],
    },
    // {
    //     type: FilterTypes.SELECT,
    //     label: 'garageType',
    //     items: ['canopy', 'attached'],
    // },
    // {
    //     type: FilterTypes.SELECT,
    //     items: ['1', '2', '3'],
    //     label: 'carsCount',
    // },
    // {
    //     type: FilterTypes.BOOLEAN,
    //     label: 'mansard',
    // },
    // {
    //     type: FilterTypes.BOOLEAN,
    //     label: 'basement',
    // },
]
export const zones: FiltersProp[] = [
    {
        type: FilterTypes.BOOLEAN,
        label: 'kitchen',
        translation: 'kitchenSeparate',
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'living',
        translation: 'livingSeparate',
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'dining',
        translation: 'diningSeparate',
    },
    // {
    //     type: FilterTypes.BOOLEAN,
    //     label: 'hallway',
    // },
    // {
    //     type: FilterTypes.BOOLEAN,
    //     label: 'hall',
    // },
    {
        type: FilterTypes.BOOLEAN,
        label: 'wardrobe',
        translation: 'wardrobeSeparate',
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'laundry',
        translation: 'laundrySeparate',
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'kitchenAndLiving',
        translation: 'kitchenAndLivingTogether',
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'livingAndDining',
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'kitchenAndDining',
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'kitchenAndLivingAndDining',
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'guestBathroom',
        // items: ['1', '2', '3'],
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'mainBathroom',
        // items: ['1', '2', '3'],
    },

    {
        type: FilterTypes.BOOLEAN,
        label: 'bedroom',
        translation: 'bedroomSeparate',
        // items: ['1', '2', '3'],
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'bedroomAndBathroom',
        // items: ['1', '2', '3'],
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'childrens',
        // items: ['1', '2', '3'],
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'childrensAndBathroom',
        // items: ['1', '2', '3'],
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'childrens2',
        // items: ['1', '2', '3'],
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'childrens2AndBathroom',
        // items: ['1', '2', '3'],
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'guest',
        // items: ['1', '2', '3'],
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'office',
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'veranda',
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'garageType',
        translation: 'garage',
    },
    {
        type: FilterTypes.BOOLEAN,
        label: 'basement',
    },
    // {
    //     type: FilterTypes.BOOLEAN,
    //     label: 'kitchenAndLivingAndVeranda',
    // },

    // {
    //     type: FilterTypes.BOOLEAN,
    //     label: 'boilerOrTechnical',
    // },

    // {
    //     type: FilterTypes.BOOLEAN,
    //     label: 'wardrobeSeparate',
    // },
]

export const SideFilter = ({
    location,
    closeHandler,
}: {
    location: string
    closeHandler?: () => void
}) => {
    const { t } = useTranslation()
    const [isZonesVisible, setIsZonesVisible] = useState(true)
    const filtersValue = searchStringToObject(location)

    const activeZones = zones.filter(({ label }) => filtersValue[label])
    const parentRef = useRef<ClearHandler>()
    return (
        <Flex
            onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                event.stopPropagation()
            }}
        >
            {closeHandler && <CloseIconStyled onClick={closeHandler} />}
            {filters.map((filter, i) => (
                <FilterItem
                    key={i * 2 + filter.type}
                    type={filter.type}
                    value={filter.value}
                    label={filter.label}
                    items={filter.items}
                    min={filter.min}
                    max={filter.max}
                    marks={filter.marks}
                    location={location}
                    ref={parentRef}
                    translation={filter.translation}
                />
            ))}

            <ZonesHeader>
                <p>
                    {t('houses.zones')} ({activeZones.length})
                </p>
                {!!activeZones.length && (
                    <Button
                        size="small"
                        onClick={() => parentRef.current?.clear()}
                        startIcon={<Icon />}
                    >
                        {t('houses.clear')}
                    </Button>
                )}
                <IconStyled
                    $isZonesVisible={isZonesVisible}
                    onClick={() => setIsZonesVisible(!isZonesVisible)}
                />
            </ZonesHeader>
            <Zones $isZonesVisible={isZonesVisible}>
                {zones.map((filter, i) => (
                    <FilterItem
                        key={i + filter.type}
                        type={filter.type}
                        value={filter.value}
                        label={filter.label}
                        items={filter.items}
                        min={filter.min}
                        max={filter.max}
                        location={location}
                        ref={parentRef}
                        activeZones={activeZones}
                        translation={filter.translation}
                    />
                ))}
            </Zones>
        </Flex>
    )
}
